import {
  Area,
  AreaChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { CARD_STATE_COLORS } from "../../../config/chartColors";
import type { CardStateTransition } from "../../../generated/graphql";

interface CardStateTimelineChartProps {
  data: CardStateTransition[];
}

export function CardStateTimelineChart({ data }: CardStateTimelineChartProps) {
  if (!data || data.length === 0) {
    return (
      <div className="chart-container">
        <div className="chart-empty">No state timeline data available</div>
      </div>
    );
  }

  const chartData = data.map((point) => ({
    date: new Date(point.date).toLocaleDateString(),
    new: point.newCards,
    learning: point.learningCards,
    review: point.reviewCards,
    relearning: point.relearningCards,
  }));

  return (
    <div className="chart-container">
      <div className="chart-header">
        <h4 className="h6">Card State Timeline</h4>
      </div>
      <div className="chart-body">
        <ResponsiveContainer width="100%" height={400}>
          <AreaChart data={chartData}>
            <defs>
              <linearGradient id="colorNew" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor={CARD_STATE_COLORS.new} stopOpacity={0.8} />
                <stop offset="95%" stopColor={CARD_STATE_COLORS.new} stopOpacity={0} />
              </linearGradient>
              <linearGradient id="colorLearning" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor={CARD_STATE_COLORS.learning} stopOpacity={0.8} />
                <stop offset="95%" stopColor={CARD_STATE_COLORS.learning} stopOpacity={0} />
              </linearGradient>
              <linearGradient id="colorReview" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor={CARD_STATE_COLORS.review} stopOpacity={0.8} />
                <stop offset="95%" stopColor={CARD_STATE_COLORS.review} stopOpacity={0} />
              </linearGradient>
              <linearGradient id="colorRelearning" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor={CARD_STATE_COLORS.relearning} stopOpacity={0.8} />
                <stop offset="95%" stopColor={CARD_STATE_COLORS.relearning} stopOpacity={0} />
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="date" />
            <YAxis label={{ value: "Cards", angle: -90, position: "insideLeft" }} />
            <Tooltip />
            <Legend />
            <Area
              type="monotone"
              dataKey="new"
              stackId="1"
              stroke={CARD_STATE_COLORS.new}
              fillOpacity={1}
              fill="url(#colorNew)"
              name="New"
            />
            <Area
              type="monotone"
              dataKey="learning"
              stackId="1"
              stroke={CARD_STATE_COLORS.learning}
              fillOpacity={1}
              fill="url(#colorLearning)"
              name="Learning"
            />
            <Area
              type="monotone"
              dataKey="review"
              stackId="1"
              stroke={CARD_STATE_COLORS.review}
              fillOpacity={1}
              fill="url(#colorReview)"
              name="Review"
            />
            <Area
              type="monotone"
              dataKey="relearning"
              stackId="1"
              stroke={CARD_STATE_COLORS.relearning}
              fillOpacity={1}
              fill="url(#colorRelearning)"
              name="Relearning"
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
